import styled from "styled-components";

export const StyledImage = styled.img`
  display: block;
`;
